import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MainHeader = () => {
  const [activeNavItem, setActiveNavItem] = useState('');
  const location = useLocation();

  const handleNavItemClick = (event:any, navItem:any) => {
    //event.preventDefault();
    setActiveNavItem(navItem);
    localStorage.setItem('activeNavItem', navItem);
  };

  useEffect(() => {
    const storedNavItem = localStorage.getItem('activeNavItem');
    if (storedNavItem) {
      setActiveNavItem(storedNavItem);
    }
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;
    const navItem = getNavItemFromPath(currentPath);
    setActiveNavItem(navItem);
    localStorage.setItem('activeNavItem', navItem);
  }, [location]);

  const getNavItemFromPath = (path:string) => {
    switch (path) {
      case '/':
        return 'Home';
      case '/DoctorProfile':
        return 'Doctor Profile';
      case '/Services':
        return 'Services';
      case '/Specialities':
        return 'Specialities';
      case '/Empanelment':
        return 'Empanelment';
      case '/EyeDiseases':
        return 'Eye Diseases';
      case '/Gallery':
        return 'Gallery';
      case '/Awards':
        return 'Awards';
      case '/Contact':
        return 'Contact';
      default:
        return '';
    }
  };

  return (
    <>
        {/* main header */}
        <header className="main-header">
        {/* header-top */}
        <div className="header-top">
            <div className="auto-container">
                <div className="top-inner">
                    <div className="left-column">
                        <ul className="info clearfix">
                            <li><i className="icon-1"></i>Email: <a href="mailto:reddyg.spurthi@gmail.com">reddyg.spurthi@gmail.com</a></li>
                            <li><i className="icon-2"></i><a href="https://maps.app.goo.gl/Coc7TBGjEj715mDs6" target="_blank" rel="noopener noreferrer">Kurnool</a></li>
                            <li><i className="icon-3"></i>Call: <a href="tel:9963276070">9963276070</a></li>
                        </ul>
                    </div>
                    <div className="right-column">
                        <div className="schedule"><i className="icon-4"></i>Mon-Sat  09:00AM-08:00PM</div>
                        <ul className="social-links clearfix">
                            <li><a href="https://www.facebook.com/profile.php?id=100091975440305&mibextid=ZbWKwL"><i className="fab fa-facebook-f"></i></a></li>
                            <li><a href="https://instagram.com/sunshineadvancedeyecare?igshid=MzRlODBiNWFlZA=="><i className="fab fa-instagram"></i></a></li>
                            <li style={{display: 'none'}}><a href="/"><i className="fab fa-twitter"></i></a></li>
                            <li style={{display: 'none'}}><a href="/"><i className="fab fa-linkedin-in"></i></a></li>
                            <li style={{display: 'none'}}><a href="/"><i className="fab fa-youtube"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        {/* header-lower */}
        <div className="header-lower">
            <div className="auto-container">
                <div className="outer-box">
                    <div className="logo-box">
                        <figure className="logo"><a href="/"><img src="assets/images/logo_new.jpeg" alt="" className="header-logo" style={{width: '66.67%', height: 'auto'}} /></a></figure>
                    </div>
                    <div className="menu-area clearfix">
                        {/* Mobile Navigation Toggler */}
                        <div className="mobile-nav-toggler">
                            <i className="icon-bar"></i>
                            <i className="icon-bar"></i>
                            <i className="icon-bar"></i>
                        </div>
                        <nav className="main-menu navbar-expand-md navbar-light">
                            <div className="collapse navbar-collapse show clearfix navbar-menu-list" id="navbarSupportedContent">
                                <ul className="navigation clearfix">
                                    <li><a href="/" className={activeNavItem === 'Home' ? 'active-nav' : ''} onClick={(e) => handleNavItemClick(e, 'Home')}>Home</a></li>
                                    {/* <li><a href="/404">About Us</a></li> */}
                                    <li><a href="/DoctorProfile" className={activeNavItem === 'Doctor Profile' ? 'active-nav' : ''} onClick={(e) => handleNavItemClick(e, 'Doctor Profile')}>Doctor Profile</a></li>
                                    <li><a href="/Services" className={activeNavItem === 'Services' ? 'active-nav' : ''} onClick={(e) => handleNavItemClick(e, 'Services')}>Services</a></li>
                                    <li><a href="/Specialities" className={activeNavItem === 'Specialities' ? 'active-nav' : ''} onClick={(e) => handleNavItemClick(e, 'Specialities')}>Specialities</a></li>
                                    <li><a href="/Empanelment" className={activeNavItem === 'Empanelment' ? 'active-nav' : ''} onClick={(e) => handleNavItemClick(e, 'Empanelment')}>Empanelment</a></li>
                                    <li><a href="/EyeDiseases" className={activeNavItem === 'Eye Diseases' ? 'active-nav' : ''} onClick={(e) => handleNavItemClick(e, 'Eye Diseases')}>Eye Diseases</a></li>
                                    <li><a href="/Gallery" className={activeNavItem === 'Gallery' ? 'active-nav' : ''} onClick={(e) => handleNavItemClick(e, 'Gallery')}>Gallery</a></li>
                                    <li><a href="/Awards" className={activeNavItem === 'Awards' ? 'active-nav' : ''} onClick={(e) => handleNavItemClick(e, 'Awards')}>Awards</a></li>
                                    <li><a href="/Contact" className={activeNavItem === 'Contact' ? 'active-nav' : ''} onClick={(e) => handleNavItemClick(e, 'Contact')}>Contact</a></li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                    {/* <div className="nav-right">
                        <div className="search-box-outer search-toggler">
                            <i className="icon-5"></i>
                        </div>
                        <div className="btn-box">
                            <a href="/" className="theme-btn btn-one">Appointment</a>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>

        {/* sticky Header */}
        <div className="sticky-header">
            <div className="auto-container">
                <div className="outer-box">
                    <div className="logo-box">
                        <figure className="logo"><a href="/"><img src="assets/images/logo_new.jpeg" alt="" className="header-logo" style={{width: '66.67%', height: 'auto'}} /></a></figure>
                    </div>
                    <div className="menu-area clearfix">
                        <nav className="main-menu clearfix">
                            {/* Keep This Empty / Menu will come through Javascript */}
                        </nav>
                    </div>
                    {/* <div className="nav-right">
                        <div className="search-box-outer search-toggler">
                            <i className="icon-5"></i>
                        </div>
                        <div className="btn-box">
                            <a href="/" className="theme-btn btn-one">Appointment</a>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
        </header>
        {/* main-header end */}
    </>
    );
  }
  
  export default MainHeader;